import { useMemo } from "react";
import { useParsedRecords } from "@/portals/patient/context/ParsedRecordsContext";
import { adaptVisit, visitSortDate } from "@/features/patient/care-treatment/utils/adaptVisit";
import type { VisitEntry } from "@/features/patient/dashboard/components/RecentVisitsModal";

interface VisitsResult {
  visits: VisitEntry[];
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

// Derived from ParsedRecordsContext instead of its own independent fetch —
// Encounter is a strict subset of that same unfiltered data, so a second API
// call here was pure duplication. No Provider needed: this is a pure
// selector over the one real fetch/loading/error/refresh state that
// ParsedRecordsContext owns.
export function useVisits(): VisitsResult {
  const { records, isLoading, error, refresh } = useParsedRecords();
  const visits = useMemo(() => {
    const encounters = records.filter((r) => r.resourceType === "Encounter");
    const sorted = [...encounters].sort((a, b) => visitSortDate(b).localeCompare(visitSortDate(a)));
    return sorted.map(adaptVisit);
  }, [records]);
  return { visits, isLoading, error, refresh };
}
